// Xử lý 401 tập trung cho các slice gọi API owner/reports (:5012).
// Token owner hạn 24h — khi backend trả 401 (hết hạn/không hợp lệ) ở BẤT KỲ API nào,
// xoá phiên và đưa về màn login. 403 (OwnerAreaForbidden) là BÌNH THƯỜNG (gọi ngoài
// vùng owner) → KHÔNG xử lý ở đây. Riêng chính request owner-login trả 401 khi sai
// mật khẩu → KHÔNG redirect (để màn Login hiển thị message), nên bỏ qua endpoint đó.
//
// Đây là lưới an toàn PHẢN ỨNG (chỉ bắt được khi có request). Việc tự đăng xuất khi
// người dùng ngồi yên không thao tác do useOwnerSession lo (chủ động, theo expiresAt).

// Utils
import { forceLogout, setAuthStuck, SESSION_NOTICE } from '@app/utils/ownerAuth';

const isLoginRequest = (args) => {
  const url = typeof args === 'string' ? args : args?.url;
  return typeof url === 'string' && url.includes('owner-login');
};

// RTK Query dùng status DẠNG CHUỖI cho lỗi không có HTTP status: 'FETCH_ERROR'
// (mất mạng, DNS, CORS bị chặn), 'TIMEOUT_ERROR'. Một 401 bị trình duyệt chặn vì
// response thiếu Access-Control-Allow-Origin rơi vào đúng nhóm này — JS KHÔNG đọc
// được số 401 (sự cố 13/08/2026: backend đặt UseCors sau UseAuthorization).
const isNetworkLevelError = (status) =>
  status === 'FETCH_ERROR' || status === 'TIMEOUT_ERROR';

// Gọi sau mỗi request:
//   · 401 (và không phải request login) → đăng xuất, về màn login;
//   · lỗi tầng mạng → KHÔNG đăng xuất (có thể chỉ mất mạng), chỉ đánh dấu phiên
//     "nghi hỏng" để người dùng vào lại được màn login (xem useAuthRedirect).
export const handleAuthError = (result, args) => {
  if (isLoginRequest(args)) {
    return result;
  }

  const status = result?.error?.status;

  if (status === 401) {
    forceLogout(SESSION_NOTICE.EXPIRED);
  } else if (isNetworkLevelError(status)) {
    setAuthStuck();
  }

  return result;
};
